class Message < ApplicationRecord
  validates :username, presence: true
  validates :body, presence: true

  # Broadcast all changes (create, update, destroy) to chat room subscribers
  broadcasts_to -> { "chat_room" }, target: "messages"
end
